import React, { ReactNode, useState } from 'react';
import { Layout as LayoutComponent } from '../Layout';
import { Layout } from 'antd';
import { selectSession, selectUser } from '../../../../redux/selectors';
import { useSelector } from 'react-redux';
import { SideBar } from '../../../../componentsV2/SideBar';

import Styles from './styles';
const { Container, Title, Contents, Header, TitleDescription } = Styles;

interface Props {
  children: React.ReactElement | React.ReactElement[];
  layoutStyle?: React.CSSProperties;
  sider?: boolean;
}

export const VerticalFixedLayout: React.FC<Props> = ({
  children,
  layoutStyle = { height: '100vh' },
  sider = true,
}) => {
  const session = useSelector(selectSession);
  const user = useSelector(selectUser);
  const [collapsed, setCollapsed] = useState(true);

  return (
    <>
      {/*<SiteNavigationBar />*/}
      <Layout style={{ ...layoutStyle }}>
        {user && sider && (
          <SideBar
            collapsed={collapsed}
            selectedKey={session.selectedSideBarOption}
            setCollapsed={setCollapsed}
          />
        )}
        <LayoutComponent sider={sider}>{children}</LayoutComponent>
      </Layout>
    </>
  );
};

interface TitledVerticalFlexLayoutProps extends Props {
  title: ReactNode;
  titleDescription?: ReactNode;
  extraTitle?: ReactNode;
}

export const TitledVerticalFlexLayout: React.FC<TitledVerticalFlexLayoutProps> = ({
  children,
  title,
  titleDescription,
  layoutStyle,
  extraTitle,
}) => {
  return (
    <VerticalFixedLayout layoutStyle={layoutStyle}>
      <Container>
        <Header>
          <Title>{title}</Title>
          {extraTitle}
        </Header>

        {titleDescription && <TitleDescription>{titleDescription}</TitleDescription>}

        <Contents hasDescription={!!titleDescription}>{children}</Contents>
      </Container>
    </VerticalFixedLayout>
  );
};
